export const funnelReviewsFilterGhibli = [
	'funnelReviews.review1',
	'funnelReviews.review2',
	'funnelReviews.review3',
];
